import { makeStyles } from '@mui/styles'

const ButtonStyles = makeStyles((theme) => ({
  buttonCustom: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #77838F',
    borderRadius: '25px',
    padding: '5px 20px',
    color: '#333E48',
    fontSize: '0.88rem',
    fontWeight: '500',
  },
}))

export default ButtonStyles
